import { action, makeObservable, observable } from 'mobx';
import type { ObservableMap } from 'mobx';

import type { TrajectoryPointMdValidationError } from '../../service/entities';

import type { TTrajectoryEditableField } from './editable-fields';

type TFieldErrors = Partial<Record<TTrajectoryEditableField, TrajectoryPointMdValidationError>>;

export class TrajectoryTableValidationStore {
  readonly errors: ObservableMap<string, TFieldErrors> = observable.map();

  constructor() {
    makeObservable(this);
  }

  getFieldError(entityId: string, field: TTrajectoryEditableField): TrajectoryPointMdValidationError | null {
    return this.errors.get(entityId)?.[field] ?? null;
  }

  @action.bound
  setFieldError(
    entityId: string,
    field: TTrajectoryEditableField,
    error: TrajectoryPointMdValidationError | null,
  ): void {
    const current = this.errors.get(entityId) ?? {};

    if (!error) {
      const { [field]: removed, ...rest } = current;

      if (removed === undefined) {
        return;
      }

      if (Object.keys(rest).length === 0) {
        this.errors.delete(entityId);
        return;
      }

      this.errors.set(entityId, rest);
      return;
    }

    this.errors.set(entityId, { ...current, [field]: error });
  }

  @action.bound
  clearPointErrors(entityId: string): void {
    this.errors.delete(entityId);
  }

  @action.bound
  clearAll(): void {
    this.errors.clear();
  }
}
